import { Box, Grid, Typography } from "@mui/material";
import "../../../utils/styles/Politicas/45001/45001Styles.scss";
import poster1 from "../../../utils/img/Politicas/seguridad.jpg";
import CircleIcon from "@mui/icons-material/FiberManualRecord";
const Politica45001 = () => {
  return (
    <Box
      style={{
        position: "relative",
        marginTop: "-20px",
        zIndex: "1",
        paddingBottom: "20px",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box className="PoliticasPortada">
        <img src={poster1} alt="" />
      </Box>
      <Box className="Container45001">
        <Grid container spacing={3} justifyContent="flex-end">
          <Grid item xs={12} md={6}>
            <Box className="PoliticasInformacion">
              <Box textAlign="center">
                <Typography className="TittlePolitica45001">
                  Política de Seguridad y Salud en el Trabajo
                </Typography>
              </Box>
              <Box>
                <Box>
                  <Typography className="TextPolitica45001">
                    TRANSMDICAS S.R.L. es una empresa de Transporte por Carretera de Materiales Peligrosos y Carga
                    en General, presente en la Industria y Minería; conscientes de nuestra responsabilidad, nos
                    comprometemos a:

                  </Typography>
                </Box>
                {/*  <Box>
                  <Typography className="TextPolitica45001">
                    Siendo conscientes de nuestra responsabilidad, nos
                    comprometemos a:
                  </Typography>
                </Box> */}
                <Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Proporcionar condiciones seguras y saludables para la prevención de accidentes, incidentes
                      y el deterioro de la salud de los trabajadores derivados de nuestras actividades.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Mantener la identificación de los peligros, evaluar, reducir los riesgos y establecer los
                      respectivos controles, con el fin de evitar y minimizar los accidentes de trabajo,
                      enfermedades ocupacionales o lesiones personales que puedan surgir en todas nuestras actividades.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Promover la seguridad de procesos basada en el comportamiento según lineamientos de
                      nuestros clientes, con el fin de mantener una cultura de seguridad psicológica.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Garantizar el derecho de negarse a realizar una tarea cuando existan condiciones que
                      atenten contra su integridad física y/o impliquen la omisión o incumplimiento de normas
                      seguras de trabajo, activando la herramienta “Para piensa y actúa” 
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Garantizar la participación y consulta activa de nuestros trabajadores y sus representantes
                      en el Sistema de Gestión de Seguridad y Salud en el trabajo
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Asegurar que todos los trabajadores de la empresa reciban capacitación continua en temas
                      de seguridad y salud en el trabajo.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Proporcionar los recursos necesarios y adecuados para el desarrollo y revisión periódica del
                      Sistema de Gestión de Seguridad y Salud en el Trabajo.
                    </Typography>
                  </Box>

                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Fortalecer la cultura de prevención de seguridad y salud en el trabajo para asegurar el
                      cumplimiento de los objetivos.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Cumplir la normatividad legal vigente aplicable en materia de seguridad y salud en el trabajo
                      y otros requisitos que la empresa suscriba
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica45001">
                      Promover la mejora continua en el desempeño de nuestro Sistema de Gestión de Seguridad
                      y Salud en el Trabajo, y que sea compatible con otros Sistemas de Gestión de la empresa.
                    </Typography>
                  </Box>
                </Box>
                <Box className="positiconversionandfecha">
                  <Typography>V.05</Typography>
                  <Typography>29/12/2025</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Politica45001;
